//@flow
import * as React from 'react';
import compose from 'recompose/compose';
import { themr } from 'react-css-themr';
import { connect } from 'react-redux';
import { dialogFactory } from 'common/components/core/dialog';
import { translate } from 'react-i18next';
import DataUtils from 'common/utils/DataUtils';
import defaultTheme from './NestedEntityDialog.scss';

const nestedEntityDialogFactory = ({
    containerFactory,
    fetchEntities,
    getFilteredEntitesCount,
    getTotalEntitiesCount
}) => {
    const PjpNestedEntityContainer = containerFactory({
        EntityEditViewContainer: null,
        EntityImportContainer: null,
        ActionsBar: null,
        fetchEntities
    });

    const DialogComponent = dialogFactory({
        InnerContent: PjpNestedEntityContainer
    });

    class NestedEntityDialog extends React.PureComponent {
        removeCheckboxes = columns => {
            // @todo: need to make this better, maybe do this in paginatedTable/masterContainer level
            return columns.filter(column => column.id !== 'selector');
        };

        render() {
            const { totalEntitiesCount, entityNameId, t, theme } = this.props;
            if (DataUtils.isEmpty(totalEntitiesCount)) {
                return null;
            }
            return (
                <DialogComponent
                    active // dialog should always be active
                    {...this.props}
                    className={theme.nestedEntityDialog}
                    title={t(`entities:${entityNameId}`, {
                        count: totalEntitiesCount
                    })}
                    customProcessColumns={this.removeCheckboxes}
                />
            );
        }
    }
    const mapStateToProps = (state, ownProps) => {
        const filteredEntitiesCount =
            getFilteredEntitesCount && getFilteredEntitesCount(state, ownProps);
        const totalEntitiesCount = getTotalEntitiesCount(state, ownProps);

        return {
            filteredEntitiesCount,
            totalEntitiesCount
        };
    };
    return compose(
        themr('NestedEntityDialog', defaultTheme),
        translate('entityManagement'),
        connect(mapStateToProps)
    )(NestedEntityDialog);
};
export { nestedEntityDialogFactory };
export default nestedEntityDialogFactory;
